import React from 'react';
import { PropTypes } from 'prop-types';
import SearchFormFilterHeader from '../../forms/CompletedForms/SearchFormFilterHeader';

export default function CustomExportGeneralFilterDropdown({
  clearFilters,
  confirm,
  filters,
  selectedKeys,
  setSelectedKeys,
  prefixCls,
  visible,
  isText
}) {
  return (
    <SearchFormFilterHeader
      clearFilters={clearFilters}
      confirm={confirm}
      filters={filters}
      selectedKeys={selectedKeys}
      setSelectedKeys={setSelectedKeys}
      prefixCls={prefixCls}
      visible={visible}
      showTextSearch
      hideList={isText}
    />
  );
}

CustomExportGeneralFilterDropdown.propTypes = {
  clearFilters: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  selectedKeys: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  setSelectedKeys: PropTypes.func.isRequired,
  prefixCls: PropTypes.string,
  visible: PropTypes.bool,
  isText: PropTypes.bool,
};

CustomExportGeneralFilterDropdown.defaultProps = {
  filters: [],
  selectedKeys: [],
  prefixCls: undefined,
  visible: false,
  isText: false,
};
